export const enDatetime = {
  // days of week
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  // days of week - short
  Sun: 'Sun',
  Mon: 'Mon',
  Tue: 'Tue',
  Wed: 'Wed',
  Thu: 'Thu',
  Fri: 'Fri',
  Sat: 'Sat',
  // time denotions
  Hour: 'Hour',
  Hours: 'Hours',
  Day: 'Day',
  Days: 'Days',
  Week: 'Week',
  Month: 'Month',
  Year: 'Year',
  // day duration filters
  CurrentMonth: 'Current Month',
  CurrentYear: 'Current Year',
  LastDay: 'Last Day',
  LastFifteenDays: 'Last 15 Days',
  LastFourteenDays: 'Last 14 Days',
  LastMonth: 'Last Month',
  LastSevenDays: 'Last 7 Days',
  LastThirtyDays: 'Last 30 Days',
  LastThirtyOneDays: 'Last 31 Days',
  LastThreeDays: 'Last 3 Days',
  LastWeekMonToSun: 'Last Week (Mon-Sat)',
  MonthToDate: 'Month To Date',
  Today: 'Today',
  WeekToDate: 'Week To Date',
  Yesterday: 'Yesterday',
  // frequency filters
  FrequencyDaily: 'Daily',
  FrequencyWeekly: 'Weekly',
  FrequencyMonthly: 'Monthly',
  // time duration filters
  FifteenMinutes: '15 Minutes',
  ThirtyMinutes: '30 Minutes',
  OneHourByMinute: '1 Hour By Minute',
  FourHoursByMinute: '4 Hours By Minute',
  FourHoursByHour: '4 Hours By Hour',
  TwelveHoursByHour: '12 Hours By Hour',
  TwentyFourHoursByHour: '24 Hours By Hour',
  WeekByHour: 'Week By Hour',
  // formats
  FormatMonthNameYear: 'MMMM YYYY',
  MomentWeekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa',
  MomentWeekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat',
  MomentWeekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday',
  MomentMonthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec',
  MomentMonths: 'January_February_March_April_May_June_July_August_September_October_November_December',
  // older calendar component presets
  ThisWeekSunToYesterday: 'This Week(Sun-Yesterday)',
  LastWeekSunToSat: 'Last Week(Sun-Sat)',
  ThisMonth: 'This Month',
  DaysUpToYesterday: 'Days Up To Yesterday',
  DaysAgoSamePeriod: 'Days Ago, Same Period',
  WeeksAgoSamePeriod: 'Weeks Ago, Same Period',
  MonthsAgoSamePeriod: 'Months Ago, Same Period',
};
